import { Variants, motion } from 'framer-motion';
import { ReactNode } from 'react';

import Sticky from '../../../../../components/StickContainer/Sticky';
import useIsMobile from '../../../../../hooks/ui/useIsMobile';

const sidebarAnimationVariants: Variants = {
    slideUpHidden: {
        y: 50,
        opacity: 0,
    },
    slideInHidden: {
        x: 50,
        opacity: 0,
    },
    slideIn: {
        x: 0,
        y: 0,
        opacity: 1,
        transition: {
            duration: 0.25,
            delay: 0.2,
            ease: 'easeOut',
        },
    },
    slideUp: {
        x: 0,
        y: 0,
        opacity: 1,
        transition: {
            duration: 0.25,
            delay: 0.2,
            ease: 'easeOut',
        },
    },
};

type StickySidebarProps = {
    children: ReactNode;
};

const StickySidebar = ({ children }: StickySidebarProps) => {
    const isMobile = useIsMobile();

    return (
        <Sticky top={16} key="sidebar">
            <motion.div
                variants={sidebarAnimationVariants}
                initial={isMobile ? 'slideUpHidden' : 'slideInHidden'}
                animate={isMobile ? 'slideUp' : 'slideIn'}
                exit={isMobile ? 'slideUpHidden' : 'slideInHidden'}
            >
                {children}
            </motion.div>
        </Sticky>
    );
};

export default StickySidebar;
